var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" 我是PageTwo: "+_vm._s(_vm.a)+" ,min: "+_vm._s(_vm.b)+" ,max: "+_vm._s(_vm.c)+" ,name: "+_vm._s(_vm.d)+" ,name2: "+_vm._s(_vm.e)+" ,way："+_vm._s(_vm.f)+" ")]),_c('p',[_vm._v(" stringName:"+_vm._s(_vm.g)+" , test5Max:"+_vm._s(_vm.h))]),_c('button',{on:{"click":_vm.startSpeaking}},[_vm._v("播放语音")])])
}
var staticRenderFns = []

export { render, staticRenderFns }